// LICENSE : MIT
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UseCaseExecutorFactory_1 = require("./UseCaseExecutorFactory");
var assert_1 = require("./util/assert");
/**
 * Maybe, `UseCaseContext` is invisible from Public API.
 *
 * `UseCase#context` return UseCaseContext insteadof Context.
 * It has limitation as against to Context.
 * Because, `UseCaseContext` is for `UseCase`, is not for `Context`.
 *
 * ```js
 * class ParentUseCase extends UseCase {
 *     execute() {
 *         this.context; // <= This is a instance of UseCaseContext
 *     }
 * }
 * ```
 */
var UseCaseContext = /** @class */ (function () {
    /**
     * `dispatcher` is often parent `UseCase`.
     * The user can not create this instance directly.
     * The user can access this via `UseCase#context`
     *
     * **internal**
     */
    function UseCaseContext(dispatcher) {
        this._dispatcher = dispatcher;
    }
    UseCaseContext.prototype.useCase = function (useCase) {
        if (process.env.NODE_ENV !== "production") {
            assert_1.assertOK(useCase !== this._dispatcher, "the useCase(" + useCase + ") should not equal this useCase(" + this._dispatcher + ")");
        }
        return UseCaseExecutorFactory_1.createUseCaseExecutor(useCase, this._dispatcher);
    };
    return UseCaseContext;
}());
exports.UseCaseContext = UseCaseContext;
//# sourceMappingURL=UseCaseContext.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/almin/lib/src/UseCaseContext.js
// module id = 473
// module chunks = 0